import createSurveyFeedbackSaga from './createSurveyFeedbackSaga'
import createSurveyFeedbackByTokenSaga from './createSurveyFeedbackByTokenSaga'
import oneSurveySaga from './oneSurveySaga'
import oneSurveyByTokenSaga from './oneSurveyByTokenSaga'
import listSurveySaga from './listSurveySaga'
import staticEnumsSaga from './staticEnumsSaga'
import createSurveySaga from './createSurveySaga'
import deleteSurveySaga from './deleteSurveySaga'
import editSurveySaga from './editSurveySaga'

const surveySagas = [
    createSurveyFeedbackSaga(),
    createSurveyFeedbackByTokenSaga(),
    oneSurveySaga(),
    oneSurveyByTokenSaga(),
    listSurveySaga(),
    staticEnumsSaga(),
    createSurveySaga(),
    deleteSurveySaga(),
    editSurveySaga()
]

export default surveySagas
